module.exports = __webpack_public_path__ + "img/web-design.5595b741.jpg";